(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.exit-mechanic-trade-warning', ['pp.widgets-templates']);

ngModule.component('ppExitMechanicTradeWarning', {
    templateUrl: 'widgets/_angular/exit-mechanic-trade-warning/exit-mechanic-trade-warning.tpl.html',
    bindings: {
        property: '<',
        isBuying: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);